import { cn } from '@/lib/cn';

export type DotTone = 'ok' | 'warn' | 'alert' | 'idle' | 'info';

const TONE_CLASS: Record<DotTone, string> = {
  ok: 'bg-accent text-accent',
  warn: 'bg-amber text-amber',
  alert: 'bg-alert text-alert',
  info: 'bg-info text-info',
  idle: 'bg-ink-faint text-ink-faint',
};

export function StatusDot({
  tone,
  pulse = false,
  className,
}: {
  tone: DotTone;
  pulse?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-block size-1.5 shrink-0 rounded-full',
        TONE_CLASS[tone],
        pulse && 'animate-pulse-dot',
        className,
      )}
      aria-hidden
    />
  );
}
